import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
const USER_API = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class UserWalletRedemptionService {
  constructor(private http: HttpClient) {}

  updatestatus(id,data): Observable<any> {
    return this.http.put(USER_API + "user-redemption/"+id , data);
  }

  adminupdatestatus(id,data,idempotencyKey): Observable<any> {
    const headers = new HttpHeaders({ 'Idempotency-Key': idempotencyKey });
    return this.http.put(USER_API + "user-redemption/"+id , data,{headers});
  }
  getList(query): Observable<any> {
    return this.http.get(USER_API + "user-redemption/"+query);
  }
  getAcademyList(query): Observable<any> {
    return this.http.get(USER_API + "user-redemption/academy-list/"+query);
  }

}
